import React, { useEffect, useState } from 'react';
import Logo from '../img/aon_logo.webp';
import { Link } from 'react-router-dom';
import Image from './Image';

function Navbar() {

    const [mobileNavbar, setMobileNavbar] = useState(false);

    useEffect(() => {
        if (mobileNavbar) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
        } else {
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
        }
    }, [mobileNavbar]);

    let showMobileNavbar = () =>{
        setMobileNavbar(true)
    }

    let removeMobileNavbar = () =>{
        setMobileNavbar(false)
    }


    return (
      <>
        <div className='navbar_section'>
            <div className="navbar_wrapper">
                <div className="navbar_logo">
                    <Link to="/"><Image src={Logo} alt="Annals of Nursing" class="logo_image"/></Link>
                </div>
                <div className='navbar_links_wrapper'>
                    <nav className='navbar_links_block'>
                        <Link className='navbar_link' to="/">Home</Link>
                        <Link className='navbar_link' to="/archive">Archive</Link>
                        <Link className='navbar_link' to="/instructions">Instructions</Link>
                        <a href="https://aseestant.ceon.rs/index.php/AnnNur/login" target='_blank' rel="noreferrer" className='navbar_link'>Submission</a>
                        <Link className='navbar_link' to="/editorial">Editorial Board</Link>
                        <Link className='navbar_link' to="/reviewers">Reviewers</Link>
                        <Link className='navbar_link' to="/contact">Contact</Link>
                    </nav>

                    <div className='navbar_hamburger' onClick={() => showMobileNavbar()}>
                        <span className="fa-solid fa-bars"></span>
                    </div>
                </div>
            </div>
        </div>

        <div className='nabvar_mobile_wrapper'  style={{ height: mobileNavbar ? "100vh" : "0px" }}>

            <div className='nabvar_mobile_block'>

                <div className='nabvar_mobile_block_x'>
                    <span onClick={() => removeMobileNavbar()} className="fa-solid fa-xmark"></span>
                </div>

                <nav className='nabvar_mobile_block_nav'>
                        <Link className='navbar_link_nav' to="/" onClick={() => removeMobileNavbar()}>Home</Link>
                        <Link className='navbar_link_nav' to="/archive" onClick={() => removeMobileNavbar()}>Archive</Link>
                        <Link className='navbar_link_nav' to="/instructions" onClick={() => removeMobileNavbar()}>Instructions</Link>
                        <a href="https://aseestant.ceon.rs/index.php/AnnNur/login" target='_blank' rel="noreferrer" className='navbar_link_nav' onClick={() => removeMobileNavbar()}>Submission</a>
                        <Link className='navbar_link_nav' to="/editorial" onClick={() => removeMobileNavbar()}>Editorial Board</Link>
                        <Link className='navbar_link_nav' to="/reviewers" onClick={() => removeMobileNavbar()}>Reviewers</Link>
                        <Link className='navbar_link_nav' to="/contact" onClick={() => removeMobileNavbar()}>Contact</Link>
                </nav>
                
            </div>

        </div>
      </>
    );
}

export default Navbar;